import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 * @param assets Array Asset serials optional list. When this is empty all available measurements for the organisation are returned
 * @param measurements Array Measurements ids for which to return samples
 * @param timezone string timezone
 * @param interval Object interval
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation, assets, measurements, interval, timeRange, timezone) {
    if (assets === void 0) { assets = []; }
    var url = applyPathVariables(EndPoints.METRICS_SAMPLES_AGGREGATE, { organisationId: organisation.id });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: {
            assetIds: assets,
            measurementIds: measurements,
            interval: interval,
            timezone: timezone,
            timeRange: timeRange
        }
    });
    return request.execute();
});
